import { useOutletContext } from 'react-router';
import { CreateSegmentCertification } from '@views/shared/certification';
import { Card, Space, Title } from 'common-components';
import { CertificationType } from '@pages/types';
import { DataLengthTag } from '@components/display';
import { useAppTranslation } from '@hooks';

const CreateSegmentCertificationPage = () => {
  const { certification } = useOutletContext<{ certification: CertificationType }>();
  const { translate } = useAppTranslation();

  return (
    <>
      <Space size={8} align={'center'} style={{ marginBottom: 22 }}>
        <Title preset="singlePageTitle">{translate('common.segments')}</Title>
        <DataLengthTag>{certification?.segmentsShort?.length || 0}</DataLengthTag>
      </Space>
      <Card style={{ width: '100%', padding: 24 }}>
        <CreateSegmentCertification certification={certification} />
      </Card>
    </>
  );
};

export default CreateSegmentCertificationPage;
